export default __webpack_public_path__ + "static/media/avatar.f7d38731.png";